import { useDispatch, useSelector } from "react-redux";

import { GroupsOutlined, HistoryOutlined, PersonOutlineOutlined, StarOutlined } from "@mui/icons-material";
import { List } from "@mui/material";

import { setOnlyIsFavorite, setOnlyLastViewedProject, setOnlyMyProject } from "slices/projects";

import styles from "./ProjectsList.module.css";
import { ProjectsListItem } from "./ProjectsListItem";

export const ProjectsList = () => {
	const dispatch = useDispatch();
	const tableViewParams = useSelector((state) => state.projects.table.viewParams);

	return (
		<div className={styles.container}>
			<div className={styles.title}>Список проектов</div>
			<List dense>
				<ProjectsListItem
					title="Все проекты"
					icon={GroupsOutlined}
					selected={
						tableViewParams.onlyMyProject !== true &&
						tableViewParams.onlyLastViewedProject !== true &&
						tableViewParams.onlyIsFavorite !== true
					}
					setProjectsGroup={() => {
						dispatch(setOnlyMyProject(false));
					}}
				/>
				<ProjectsListItem
					title="Мои проекты"
					icon={PersonOutlineOutlined}
					selected={tableViewParams.onlyMyProject === true}
					setProjectsGroup={() => {
						dispatch(setOnlyMyProject(true));
					}}
				/>
				<ProjectsListItem
					title="Недавно открытые"
					icon={HistoryOutlined}
					selected={tableViewParams.onlyLastViewedProject === true}
					setProjectsGroup={() => {
						dispatch(setOnlyLastViewedProject(true));
					}}
				/>
				<ProjectsListItem
					title="Избранное"
					icon={StarOutlined}
					selected={tableViewParams.onlyIsFavorite === true}
					setProjectsGroup={() => {
						dispatch(setOnlyIsFavorite(true));
					}}
				/>
			</List>
		</div>
	);
};
